import React from 'react';
import { CONTENT_BASE } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const CloseIcon: React.FC<{}> = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
            <title>{translated('Accessibility.SvgTitle.closeIcon')}</title>
            <g id='web_close'>
                <path
                    d='M21.5 12.5H2.5C2.2 12.5 2 12.3 2 12C2 11.7 2.2 11.5 2.5 11.5H21.5C21.8 11.5 22 11.7 22 12C22 12.3 21.8 12.5 21.5 12.5Z'
                    fill={CONTENT_BASE}
                    stroke={CONTENT_BASE}
                    strokeWidth='0.175'
                />
            </g>
        </svg>
    );
};
